<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <v-list-item v-for="item in items" :key="item.text" link>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-subheader class="mt-4 grey--text text--darken-1">Subscriptions</v-subheader>
        <v-list>
          <v-list-item v-for="item in items2" :key="item.text" link>
            <v-list-item-avatar>
              <img :src="`https://randomuser.me/api/portraits/men/${item.picture}.jpg`" alt />
            </v-list-item-avatar>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list-item class="mt-4" link>
          <v-list-item-action>
            <v-icon color="grey darken-1">mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title class="grey--text text--darken-1">チャンネルを探す</v-list-item-title>
        </v-list-item>
        <v-list-item link>
          <v-list-item-action>
            <v-icon color="grey darken-1">mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-title class="grey--text text--darken-1">登録チャンネルを管理</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="red" dense>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-icon class="mx-4" large>mdi-youtube</v-icon>
      <v-toolbar-title class="mr-12 align-center">
        <span class="title">LLTube</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row align="center" style="max-width: 650px">
        <v-text-field
          :append-icon-cb="() => {}"
          placeholder="検索..."
          single-line
          append-icon="mdi-magnify"
          color="white"
          hide-details
        ></v-text-field>
      </v-row>
    </v-app-bar>

    <v-main>
      <v-overlay opacity="0">
        <div v-for="star in stars" :key="star.id">
          <star v-bind:star="star" v-bind:class="star.class"></star>
        </div>
      </v-overlay>
      <v-container class="fill-height">
        <v-row class="fill-height" justify="center" align="center">
          <v-col class="fill-height">
            <youtube
              :video-id="videoId"
              :player-vars="playerVars"
              @playing="playing"
              @paused="paused"
              fitParent
            />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { db } from "./firebaseDb.js";
import Star from "./components/Star.vue";

export default {
  props: {
    source: String,
  },
  components: {
    Star,
  },
  data: () => ({
    drawer: null,
    items: [
      { icon: "mdi-trending-up", text: "人気" },
      { icon: "mdi-youtube-subscription", text: "登録チャンネル" },
      { icon: "mdi-history", text: "履歴" },
      { icon: "mdi-playlist-play", text: "プレイリスト" },
      { icon: "mdi-clock", text: "あとで見るリスト" },
    ],
    items2: [],
    videoId: "naMHtah5Gz8",
    playerVars: {
      autoplay: 1,
    },
    stars: [],
    onPlaying: false,
    counter: 0,
  }),
  created() {
    this.$vuetify.theme.dark = true;
    const ref = db.ref("M5StickC/shake");
    ref.on("child_added", this.addStar);
  },
  methods: {
    playing() {
      this.onPlaying = true;
    },
    paused() {
      this.onPlaying = false;
    },
    addStar(snap) {
      if (!this.onPlaying) return;
      const newItem = snap.val();
      this.stars.push({
        id: snap.key,
        member: newItem.color,
        strength: newItem.strength,
        top: "50%",
        left: "50%",
        class: `star${this.updateCounter()}`,
      });
      const time = 3200;
      setTimeout(this.removeStar, time, snap.key);
    },
    removeStar(id) {
      const index = this.stars.findIndex((star) => (star.id = id));
      this.stars.splice(index, 1);
    },
    updateCounter() {
      if (this.counter === 8) {
        this.counter = 1;
        return this.counter;
      }
      this.counter += 1;
      return this.counter;
    },
  },
};
</script>